import React from 'react';
import styles from './carouselNavigation.module.scss';
import Selectors from 'src/utils/selectors';

export default function CarouselNavigation({
    activeIndicator,
    noOfIndicators
}: {
    activeIndicator: number;
    noOfIndicators: number;
}): JSX.Element {
    return (
        <div className={styles.row} data-cy={Selectors.SpendSmart.CAROUSEL_NAVIGATION}>
            {Array.from({ length: noOfIndicators }).map((_, index) => (
                <div
                    key={index}
                    className={`${styles.indicator}${activeIndicator === index ? ' ' + styles.active : ''}`}
                />
            ))}
        </div>
    );
}
